import { render } from "./DetailModal.vue?vue&type=template&id=8819c664&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"

import "./DetailModal.vue?vue&type=style&index=0&id=8819c664&scoped=true&lang=less"
import "./DetailModal.vue?vue&type=style&index=1&id=8819c664&lang=css"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8819c664"]])

export default __exports__